module.exports = __webpack_public_path__ + "static/media/m-logo.962a5d8f.png";